import BadgeSuccess from "../../components/badgeBorder/successBadge";
import BadgeDanger from "../../components/badgeBorder/dangerBadge";
import BadgeWarning from "../../components/badgeBorder/warningBadge";
import DateFormat from "../../components/dateFormater/dateFormat1";
import { planTrainingMainOne } from "../../config/apiSPA";
import { useEffect, useState } from "react";

function StatusBadge({ data }) {
  const [rescheduleDate, setRescheduleDate] = useState("-");
  const loadReschedulePlan = async (id) => {
    try {
      const res = await planTrainingMainOne(id);
      setRescheduleDate(DateFormat(res.data.start));
    } catch (error) {
      setRescheduleDate("[date not found]");
    }
  };
  const badge = {
    PLANNED: <BadgeSuccess text={"PLANNED"} />,
    CANCEL: <BadgeDanger text={"CANCELED"} />,
    RESCHEDULE: <BadgeWarning text={`RESCHEDULE to ${rescheduleDate}`} />,
  };

  useEffect(() => {
    if (data.rescheduleTo) {
      loadReschedulePlan(data.rescheduleTo);
    }
  }, [data?.rescheduleTo, data?.status]);
  return (
    <>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">{badge[data?.status?.toUpperCase() || null]}</div>
        </div>
      </div>
    </>
  );
}

export default StatusBadge;
